<template>
  <esg022 />
</template>

<script>
import esg022 from '@/pages/esg/p_esg022.vue';

export default {
  components: {
    esg022
  }
};
</script>
